const STORES = ['Coles', 'Woolworths', 'Aldi'];
const STORE_COLOR = { Coles: '#E50016', Woolworths: '#129C4F', Aldi: '#001E5E' };

export default function PriceSummaryFooter({ items, prices, priceMode }) {
  if (!items.length) return null;

  // Calculate totals
  function storeTotal(store) {
    return items.reduce((sum, item) => {
      const p = prices?.[item.name]?.[store]?.price ?? null;
      return p !== null ? sum + p * (item.quantity || 1) : sum;
    }, 0);
  }

  function lowestTotal() {
    return items.reduce((sum, item) => {
      const storePrices = STORES.map(s => prices?.[item.name]?.[s]?.price ?? null).filter(p => p !== null);
      const min = storePrices.length ? Math.min(...storePrices) : null;
      return min !== null ? sum + min * (item.quantity || 1) : sum;
    }, 0);
  }

  const totals = {
    lowest:      lowestTotal(),
    Coles:       storeTotal('Coles'),
    Woolworths:  storeTotal('Woolworths'),
    Aldi:        storeTotal('Aldi'),
  };

  const storeTotalsWithPrice = STORES.filter(s => totals[s] > 0);
  const maxTotal = storeTotalsWithPrice.length
    ? Math.max(...storeTotalsWithPrice.map(s => totals[s]))
    : 0;

  if (priceMode === 'all') {
    return (
      <div className="slf-wrap slf-wrap--all">
        <div className="slf-row slf-row--best">
          <span className="slf-label">Best possible total</span>
          <span className="slf-amount slf-amount--best">${totals.lowest.toFixed(2)}</span>
        </div>
        {STORES.filter(s => totals[s] > 0).map(s => {
          const diff = totals[s] - totals.lowest;
          return (
            <div key={s} className="slf-row">
              <span className="slf-label">
                <span className="slf-store-dot" style={{ background: STORE_COLOR[s] }} />
                {s} only
              </span>
              <span className="slf-amount">${totals[s].toFixed(2)}</span>
              {diff > 0.01 && (
                <span className="slf-diff">+${diff.toFixed(2)}</span>
              )}
            </div>
          );
        })}
        {maxTotal > totals.lowest + 0.01 && (
          <div className="slf-savings-note">
            💡 You save up to <strong>${(maxTotal - totals.lowest).toFixed(2)}</strong> by choosing the best store per item
          </div>
        )}
      </div>
    );
  }

  if (priceMode === 'lowest') {
    return (
      <div className="slf-wrap">
        <div className="slf-row slf-row--best">
          <span className="slf-label">Total (best prices)</span>
          <span className="slf-amount slf-amount--best">${totals.lowest.toFixed(2)}</span>
        </div>
        {maxTotal > totals.lowest + 0.01 && (
          <div className="slf-savings-note">
            💡 Save up to <strong>${(maxTotal - totals.lowest).toFixed(2)}</strong> vs shopping at one store
          </div>
        )}
      </div>
    );
  }

  // Single store mode
  const t = totals[priceMode] || 0;
  return (
    <div className="slf-wrap">
      <div className="slf-row">
        <span className="slf-label" style={{ color: STORE_COLOR[priceMode] }}>
          {priceMode} total
        </span>
        <span className="slf-amount">${t.toFixed(2)}</span>
      </div>
      {totals.lowest > 0 && t > totals.lowest + 0.01 && (
        <div className="slf-savings-note">
          💡 Save <strong>${(t - totals.lowest).toFixed(2)}</strong> by mixing stores
        </div>
      )}
    </div>
  );
}
